export const comparisonTypes = {
   equals: 'equals',
   containsExactTruthyValues: 'containsExactTruthyValues',
};
